// extracted by mini-css-extract-plugin
export default {"chip":"CategoryRiskLevel_chip__7bGMA"};